import React from 'react';
import {Form} from '@yandex-data-ui/cloud-schemas/build/models/ui-api';

export type FormsData = {
    [key: string]: Form;
};

export default React.createContext<FormsData>({});
